exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-cropper__button--wrapper{display:flex;justify-content:space-between;background:#111215}.image-cropper__button{background:transparent;height:3rem;line-height:3rem;color:#ebebeb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ImageCropper/ImageCropper.scss
// module id = 681
// module chunks = 0